<template>
    <div>
        <div class="card card-box mb-3">
            <div class="card-body p-4">
                <h5>Pemeriksaan Fisik</h5>
                <b-row class="mt-5" v-show="kategoriPasien == 2">
                    <b-col lg="12" md="12">
                        <div class="form-group row mb-header">
                            <label for="staticEmail" class="col-sm-3 col-form-label"> Kesadaran</label>
                            <div class="col-sm-9 form-control-plaintext">
                                <strong>{{
                                    dataRM.bpjs_nmSadar || "-"
                                }}</strong>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <b-row class="mt-2">
                    <b-col lg="12" md="12">
                        <div class="form-group row mb-header">
                            <label for="staticEmail" class="col-sm-3 col-form-label">Tingkat Kesadaran</label>
                            <div class="col-sm-9 form-control-plaintext">
                                <strong>{{
                                    dataRM.pemeriksaan_fisik.tingkat_kesadaran || "-"
                                }}</strong>
                            </div>
                        </div>
                    </b-col>
                </b-row>

                <b-row class="mt-5">
                    <b-col lg="6" md="6">
                        <b-img v-bind:src="drawPath" fluid></b-img>
                    </b-col>
                    <b-col lg="6" md="6">
                        <div v-html="this.dataRM.pemeriksaan_fisik.notes"></div>
                    </b-col>
                </b-row>
            </div>
        </div>

        <div class="card card-box mb-3">
            <div class="card-body p-4">
                <div class="row">
                    <div class="col-md-4">
                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Luas Permukaan Tubuh Untuk Anak-Anak</div>
                            <div class="col-md-6">{{ dataRM.pemeriksaan_fisik.luas_fisik || '-' }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Kepala</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.kepala, dataRM.pemeriksaan_fisik.ket_kepala) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Mata</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.mata, dataRM.pemeriksaan_fisik.ket_mata) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Telinga</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.telinga, dataRM.pemeriksaan_fisik.ket_telinga) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Hidung</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.hidung, dataRM.pemeriksaan_fisik.ket_hidung) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Rambut</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.rambut, dataRM.pemeriksaan_fisik.ket_rambut) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Bibir</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.bibir, dataRM.pemeriksaan_fisik.ket_bibir) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Gigi Geligi</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.gigi_geligi, dataRM.pemeriksaan_fisik.ket_gigi_geligi) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Lidah</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.lidah, dataRM.pemeriksaan_fisik.ket_lidah) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Langit-Langit</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.langit_langit, dataRM.pemeriksaan_fisik.ket_langit_langit) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Leher</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.leher, dataRM.pemeriksaan_fisik.ket_leher) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Tenggorokan</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.tenggorokan, dataRM.pemeriksaan_fisik.ket_tenggorokan) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Tonsil</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.tonsil, dataRM.pemeriksaan_fisik.ket_tonsil) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Dada</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.dada, dataRM.pemeriksaan_fisik.ket_dada) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Payudara</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.payudara, dataRM.pemeriksaan_fisik.ket_payudara) }}</div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Punggung</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.punggung, dataRM.pemeriksaan_fisik.ket_punggung) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Perut</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.perut, dataRM.pemeriksaan_fisik.ket_perut) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Genital</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.genital, dataRM.pemeriksaan_fisik.ket_genital) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Anus/Dubur</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.anus, dataRM.pemeriksaan_fisik.ket_anus) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Lengan Atas</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.lengan_atas, dataRM.pemeriksaan_fisik.ket_lengan_atas) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Lengan Bawah</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.lengan_bawah, dataRM.pemeriksaan_fisik.ket_lengan_bawah) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Jari Tengah</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.jari_tangan, dataRM.pemeriksaan_fisik.ket_jari_tangan) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Kuku Tangan</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.kuku_tangan, dataRM.pemeriksaan_fisik.ket_kuku_tangan) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Persendian Tangan</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.persendian_tangan, dataRM.pemeriksaan_fisik.ket_persendian_tangan) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Tungkai Atas</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.tungkai_atas, dataRM.pemeriksaan_fisik.ket_tungkai_atas) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Tungkai Bawah</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.tungkai_bawah, dataRM.pemeriksaan_fisik.ket_tungkai_bawah) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Jari Kaki</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.jari_kaki, dataRM.pemeriksaan_fisik.ket_jari_kaki) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Kuku Kaki</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.kuku_kaki, dataRM.pemeriksaan_fisik.ket_kuku_kaki) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Persendian Kaki</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.persendian_kaki, dataRM.pemeriksaan_fisik.ket_persendian_kaki) }}</div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Status Psikologis</div>
                            <div class="col-md-6">{{ getStatusPsikologis(dataRM.pemeriksaan_fisik.status_psikologis) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Sosial Ekonomi</div>
                            <div class="col-md-6">{{ dataRM.pemeriksaan_fisik.sosial_ekonomi || '-' }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Spiritual</div>
                            <div class="col-md-6">{{ dataRM.pemeriksaan_fisik.spiritual || '-' }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Poliklinik",
    props: ["dataRM"],
    data() {
        return {
            drawPath: null,
            kategoriPasien: null,
            kodeSadar: [
                {
                    kdSadar: "01",
                    nmSadar: "Compos mentis"
                },
                {
                    kdSadar: "02",
                    nmSadar: "Somnolence"
                },
                {
                    kdSadar: "03",
                    nmSadar: "Sopor"
                },
                {
                    kdSadar: "04",
                    nmSadar: "Coma"
                }
            ],
            kesadaran: null
        }
    },
    mounted() {
        this.buildData()
    },
    watch: {
        dataRM(val) {
            this.buildData()
        }
    },
    computed: {
        
    },
    methods: {
        getStatusPsikologis(status) {
            const statusMapping = {
                N: "Tidak Ada Kelainan",
                C: "Cemas",
                T: "Takut",
                M: "Marah",
                S: "Sedih",
                L: `Lain-Lain, ${this.dataRM.pemeriksaan_fisik.ket_status_psikologis}` 
            };

            return statusMapping[status] || "-";
        },
        convertData(status, content){
            if(status == 'T'){
                return 'Tidak Ada Kelainan'
            }

            if(status == 'Y'){
                return `Ada Kelainan, ${content}`
            }

            if(status == 'N'){
                return `Tidak Diperiksa`
            }
            return '-'
        },
        buildData() {
            this.kategoriPasien = this.dataRM.transklinik.kategori_id
            this.drawPath = this.dataRM.pemeriksaan_fisik.draw_path;

            if (this.kategoriPasien == 2) {
                this.kesadaran = this.kodeSadar.find((({ kdSadar }) => kdSadar == this.dataRM.bpjs_kdSadar))
            }
        }
    }
}
</script>

<style>
.mb-header {
    margin-bottom: -15px;
}
</style>